import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import LoadingComponent from "components/LoadingComponent";

import { userCustomerAuthenticationServices } from "services/userCustomerAuthentication";

import { stringFormat } from "utils/stringFormat";

import { LeftFormContainer, LoadingContainer } from "../styles";
import {
  ForgotPasswordStepOne,
  ForgotPasswordStepTwo,
  validEmail,
} from "./constants";

interface IBaseRestAPIResponse {
  data: any;
  status: number;
}

export const ForgotPassword: React.FC<{
  navigate?: any;
  navigateTo?: string;
  url?: string;

  addToast?: any;
}> = ({ navigate, navigateTo, addToast }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [stepTwo, setStepTwo] = useState(false);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState<string>("");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (stringFormat.isEmptyOrSpaces(email)) {
      setError(true);
      addToast({
        type: "warning",
        title: t("auth.forgotPassword.emailError"),
        description: t("auth.forgotPassword.fillValidEmail"),
      });
      return;
    }

    if (!verifyNumberOfTries()) {
      return;
    }

    const isValid = validEmail(email);

    if (!isValid) {
      addToast({
        type: "warning",
        title: t("auth.forgotPassword.emailError"),
        description: t("auth.forgotPassword.checkValidEmail"),
      });
      setError(true);
      return;
    } else {
      setError(false);
      setLoading(true);

      const { data, status }: IBaseRestAPIResponse =
        await userCustomerAuthenticationServices.forgotPassword({
          email: email,
          plataform: 0,
        });

      if (status === 200) {
        setStepTwo(true);
      } else {
        addToast({
          type: "error",
          title: "Erro",
          description: data || "E-mail inválido.",
        });
        setExpirationTime();
      }

      setLoading(false);
    }
  };

  const setExpirationTime = () => {
    const exTimeValue = localStorage.getItem(
      "@Kenta:expirationTimeForgotPassword",
    );

    if (exTimeValue) {
      // o tipo é {tries: number, time: string}
      const expirationTime = JSON.parse(exTimeValue);

      if (expirationTime.tries === 3) {
        return;
      }

      expirationTime.tries = expirationTime.tries + 1;
      const currentDate = new Date();
      expirationTime.time = new Date(currentDate.getTime() + 60 * 60 * 1000);
      localStorage.setItem(
        "@Kenta:expirationTimeForgotPassword",
        JSON.stringify(expirationTime),
      );
    } else {
      const expirationTime = {
        tries: 1,
        time: new Date().getTime() + 60 * 60 * 1000,
      };
      localStorage.setItem(
        "@Kenta:expirationTimeForgotPassword",
        JSON.stringify(expirationTime),
      );
    }
  };

  function verifyNumberOfTries() {
    const exTimeValue = localStorage.getItem(
      "@Kenta:expirationTimeForgotPassword",
    );
    if (exTimeValue) {
      const expirationTime = JSON.parse(exTimeValue);
      if (expirationTime.tries === 3) {
        const storedTime = new Date(expirationTime.time);
        const currentTime = new Date();
        const isOneHourPassed = currentTime > storedTime;

        if (!isOneHourPassed) {
          addToast({
            type: "warning",
            title: t("auth.forgotPassword.attemptsExceeded"),
            description: t("auth.forgotPassword.attemptsExceededDesc"),
          });
          return false;
        } else {
          localStorage.removeItem("@Kenta:expirationTimeForgotPassword");
        }
      }
    }
    return true;
  }

  return (
    <LeftFormContainer>
      {!stepTwo
        ? ForgotPasswordStepOne(
            email,
            setEmail,
            handleSubmit,
            error,
            setError,
            navigate,
            t,
          )
        : ForgotPasswordStepTwo(navigate, navigateTo ?? "/", t)}
      {loading && (
        <LoadingContainer>
          <LoadingComponent loading={loading} />
        </LoadingContainer>
      )}
    </LeftFormContainer>
  );
};
